import { Spin } from 'antd'

interface PageLoadingProps {
  tip?: string
}

/**
 * Consistent full-page loading indicator.
 * Use this in place of ad-hoc Spin/Progress components across pages.
 */
export function PageLoading({ tip = 'Loading...' }: PageLoadingProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
      <Spin size="large" tip={tip}>
        {/* Spin requires a child element when using the tip prop */}
        <div style={{ minHeight: 100 }} />
      </Spin>
    </div>
  )
}
